var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "order-confirmed" }, [
    !_vm.order
      ? _c("div", { staticClass: "panel panel-default" }, [
          _c("h4", { staticClass: "text-center" }, [
            _vm._v("\n\t\t\tAucune commande à afficher\n\t\t\t"),
            _vm.loading ? _c("i", { staticClass: "loading" }) : _vm._e(),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.order
      ? _c("div", { staticClass: "container my-50 flex-center-center" }, [
          _c(
            "div",
            {
              staticClass:
                "bg-white flex-center-center flex-column no-overflow radius-20 shadow-3 w-100 size-max-w-400",
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "bg-color2 color-white fsize-18 m-0 p-20 text-center w-100",
                },
                [
                  _c("div", { staticClass: "fsize-26 text-uppercase" }, [
                    _vm._v("Merci!"),
                  ]),
                  _vm._v(" "),
                  _c("div", [_vm._v("Votre commande est confirmée")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "color-grey1 fsize-20 mt-5" }, [
                    _vm._v(
                      "Nº " +
                        _vm._s(
                          _vm.order.OrderId.toLocaleString("en").replaceAll(
                            ",",
                            "-"
                          )
                        )
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.order.SaleAreaId == _vm.ShopService.SALE_AREAS.DELIVERY
                ? _c(
                    "div",
                    { staticClass: "flex-center-center flex-column p-10" },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "fsize-20 text-bold mt-20 text-center" },
                        [_vm._v("Livraison prévue")]
                      ),
                      _vm._v(" "),
                      !_vm.order.stuart_job_id
                        ? _c(
                            "div",
                            { staticClass: "fsize-40 text-bold color-1 mt-10" },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.extractDeliveryTime(
                                      _vm.order.PickupTimeDate
                                    )
                                  ) +
                                  "\n\t\t\t\t"
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.order.stuart_job_id
                        ? _c(
                            "div",
                            { staticClass: "fsize-40 text-bold color-1 mt-10" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.stuart_job
                                    ? _vm
                                        .moment(_vm.stuart_job.dropoff_at)
                                        .format("HH:mm")
                                    : ""
                                ) + "\n\t\t\t\t"
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.order.stuart_job_id
                        ? _c(
                            "div",
                            {
                              staticClass: "my-10 link-color2 fsize-12",
                              on: {
                                click: function ($event) {
                                  return _vm.toggleJob()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\tVoir le suivi de votre livraison "
                              ),
                              _c("collapse-indicator", {
                                attrs: {
                                  loading: _vm.stuartProcessing,
                                  open: _vm.stuart_job,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("collapse-transition", [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.stuart_job,
                                expression: "stuart_job",
                              },
                            ],
                            staticClass: "my-10 link-color2 fsize-12",
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\tSuivi de votre livraison Stuart:\n\t\t\t\t\t"
                            ),
                            _c("stuart-job", {
                              attrs: { job: _vm.stuart_job },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-10" }, [
                        _c(
                          "a",
                          {
                            staticClass:
                              "fsize-14 color-1 hover-grey1 flex-center-center",
                            attrs: {
                              target: "_blank",
                              href: `https://www.google.com/maps/@${
                                _vm.order.address.Location.latitude
                              },${
                                _vm.order.address.Location.longitude
                              },16z?q=${_vm.gmapsQuery(_vm.order.address)}`,
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "fsize-18 fie-icon_pin mr-5",
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "mr-5" }, [
                              _vm._v(
                                _vm._s(_vm.order.address.PlusCode) +
                                  "\n\t\t\t\t\t\t\t" +
                                  _vm._s(_vm.order.address.Company) +
                                  " " +
                                  _vm._s(_vm.order.address.Address) +
                                  ", " +
                                  _vm._s(_vm.order.address.Zip) +
                                  "\n\t\t\t\t\t\t"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "text-uppercase" }, [
                              _vm._v(_vm._s(_vm.order.address.City)),
                            ]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-5" }, [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(_vm.order.address.Commentaire) +
                            "\n\t\t\t\t"
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.order.SaleAreaId == _vm.ShopService.SALE_AREAS.TO_STAY ||
              _vm.order.SaleAreaId == _vm.ShopService.SALE_AREAS.TO_GO
                ? _c(
                    "div",
                    { staticClass: "flex-center-center flex-column p-10" },
                    [
                      _vm.order.SaleAreaId == _vm.ShopService.SALE_AREAS.TO_STAY
                        ? _c(
                            "div",
                            { staticClass: "flex-center-center flex-column" },
                            [
                              _vm._m(1),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "fsize-20 text-bold mt-20 text-center",
                                },
                                [_vm._v("À consommer sur place")]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.order.SaleAreaId == _vm.ShopService.SALE_AREAS.TO_GO
                        ? _c(
                            "div",
                            { staticClass: "flex-center-center flex-column" },
                            [
                              _vm._m(2),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "fsize-20 text-bold mt-20 text-center",
                                },
                                [_vm._v("À emporter")]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "fsize-40 text-bold color-1 mt-10" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.extractOrderTime(_vm.order.PickupTimeDate)
                            )
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-10" }, [
                        _c(
                          "a",
                          {
                            staticClass:
                              "fsize-14 color-1 hover-grey1 flex-center-center",
                            attrs: {
                              target: "_blank",
                              href: `https://www.google.com/maps/@${_vm.order.shop.Location.latitude},${_vm.order.shop.Location.longitude},16z?q=${_vm.order.shop.Location.latitude},${_vm.order.shop.Location.longitude}`,
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "fsize-18 fie-icon_pin mr-5",
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "text-bold mr-5" }, [
                              _vm._v(_vm._s(_vm.order.shop.DefaultName) + " "),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "mr-5" }, [
                              _vm._v(
                                _vm._s(_vm.order.shop.Address1) +
                                  " " +
                                  _vm._s(_vm.order.shop.Address2) +
                                  ", " +
                                  _vm._s(_vm.order.shop.Zip) +
                                  "\n\t\t\t\t\t\t"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "text-uppercase" }, [
                              _vm._v(_vm._s(_vm.order.shop.City)),
                            ]),
                          ]
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.order.SaleAreaId == _vm.ShopService.SALE_AREAS.RESTAURANT
                ? _c(
                    "div",
                    { staticClass: "flex-center-center flex-column p-10" },
                    [
                      _vm.order.SaleAreaId ==
                      _vm.ShopService.SALE_AREAS.RESTAURANT
                        ? _c(
                            "div",
                            { staticClass: "flex-center-center flex-column" },
                            [
                              _vm._m(3),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "fsize-20 text-bold mt-20 text-center",
                                },
                                [_vm._v("Table " + _vm._s(_vm.order.Table))]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      false
                        ? _c(
                            "div",
                            { staticClass: "fsize-40 text-bold color-1 mt-10" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.extractOrderTime(_vm.order.PickupTimeDate)
                                )
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-10" }, [
                        _c(
                          "a",
                          {
                            staticClass:
                              "fsize-14 color-1 hover-grey1 flex-center-center",
                            attrs: {
                              target: "_blank",
                              href: `https://www.google.com/maps/@${_vm.order.shop.Location.latitude},${_vm.order.shop.Location.longitude},16z?q=${_vm.order.shop.Location.latitude},${_vm.order.shop.Location.longitude}`,
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "fsize-18 fie-icon_pin mr-5",
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "text-bold mr-5" }, [
                              _vm._v(_vm._s(_vm.order.shop.DefaultName) + " "),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "mr-5" }, [
                              _vm._v(
                                _vm._s(_vm.order.shop.Address1) +
                                  " " +
                                  _vm._s(_vm.order.shop.Address2) +
                                  ", " +
                                  _vm._s(_vm.order.shop.Zip) +
                                  "\n\t\t\t\t\t\t"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "text-uppercase" }, [
                              _vm._v(_vm._s(_vm.order.shop.City)),
                            ]),
                          ]
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "my-40 p-10" }, [
                _c(
                  "a",
                  {
                    staticClass:
                      "btnFlat-color2 bg-hover-white hover-color2 shadow-1",
                    attrs: {
                      href: _vm.ShopId + "/client/orders/" + _vm.order.OrderId,
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.UrlService.replace({
                          name: "client-orders.current",
                          params: {
                            order: _vm.order,
                            ShopId: _vm.ShopId,
                            OrderId: _vm.order.OrderId,
                            isOrderConfirmation: true,
                          },
                        })
                      },
                    },
                  },
                  [_vm._v("\n\t\t\t\t\tVoir la commande\n\t\t\t\t")]
                ),
              ]),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "flex-center-center mt-30 size-wh-150 radius-circle bg-white shadow-4",
      },
      [_c("i", { staticClass: "fsize-60 fie-icon_delivery" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "flex-center-center mt-30 size-wh-150 radius-circle bg-white shadow-4",
      },
      [_c("i", { staticClass: "fsize-60 fie-icon_store" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "flex-center-center mt-30 size-wh-150 radius-circle bg-white shadow-4",
      },
      [_c("i", { staticClass: "fsize-60 fie-icon_takeaway2" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "flex-center-center mt-30 size-wh-150 radius-circle bg-white shadow-4",
      },
      [_c("i", { staticClass: "fsize-60 fie-icon_store" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }